import getEnvValue from './getEnvValue';

export const UNKNOWN_ENVIRONMENT = 'unknown';

// Resolved on every call rather than memoized at module scope: globalThis._env_
// is populated at runtime, so a module evaluated before that happens would
// otherwise cache 'unknown' for the lifetime of the process (CON-8595).
const getEnvironmentName = () =>
  getEnvValue('REACT_APP_ENV_NAME') ??
  getEnvValue('NEXT_PUBLIC_ENV_NAME') ??
  UNKNOWN_ENVIRONMENT;

export default getEnvironmentName;
